import { initializeApp } from "firebase/app"
import { getAnalytics, isSupported, logEvent, Analytics } from "firebase/analytics"

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDb7WZ2UPPpx6Ve6r1-ylOrGsHrZmaJ99k",
    authDomain: "dpxp-457101.firebaseapp.com",
    projectId: "dpxp-457101",
    storageBucket: "dpxp-457101.firebasestorage.app",
    messagingSenderId: "186788157157",
    appId: "1:186788157157:web:eb0b293eddaea855cc260c",
    measurementId: "G-XJXRLY9YPC"
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)

// Analytics instance (lazy initialized)
let analyticsInstance: Analytics | null = null

// Initialize Analytics (only in browser and when supported)
export const initAnalytics = async () => {
    if (typeof window !== 'undefined' && await isSupported()) {
        analyticsInstance = getAnalytics(app)
        return analyticsInstance
    }
    return null
}

// Get analytics instance
const getAnalyticsInstance = () => analyticsInstance

// Track button/link clicks
export const trackClick = (elementName: string, section: string, metadata?: Record<string, string>) => {
    const analytics = getAnalyticsInstance()
    if (analytics) {
        logEvent(analytics, 'click', {
            element_name: elementName,
            section: section,
            ...metadata
        })
    }
}

// Track navigation clicks
export const trackNavigation = (destination: string, source: 'header' | 'footer' | 'mobile_menu') => {
    const analytics = getAnalyticsInstance()
    if (analytics) {
        logEvent(analytics, 'navigation_click', {
            destination: destination,
            source: source
        })
    }
}

// Track CTA button clicks
export const trackCTA = (ctaName: string, section: string) => {
    const analytics = getAnalyticsInstance()
    if (analytics) {
        logEvent(analytics, 'cta_click', {
            cta_name: ctaName,
            section: section
        })
    }
}

// Track external link clicks (WhatsApp, LinkedIn, etc)
export const trackExternalLink = (linkType: string, destination: string, section: string) => {
    const analytics = getAnalyticsInstance()
    if (analytics) {
        logEvent(analytics, 'external_link_click', {
            link_type: linkType,
            destination: destination,
            section: section
        })
    }
}

// Track scroll depth within a section
export const trackScrollDepth = (sectionId: string, percentage: 25 | 50 | 75 | 100) => {
    const analytics = getAnalyticsInstance()
    if (analytics) {
        logEvent(analytics, 'scroll_depth', {
            section_id: sectionId,
            scroll_percentage: percentage // Número: cadastrar como Métrica Customizada no GA4
        })
    }
}

// Track time spent viewing a section (in seconds)
export const trackSectionView = (sectionId: string, timeSpentSeconds: number) => {
    const analytics = getAnalyticsInstance()
    if (analytics) {
        // Only track if user spent at least 2 seconds (avoid accidental scrolls)
        if (timeSpentSeconds >= 2) {
            logEvent(analytics, 'section_view', {
                section_id: sectionId,
                time_spent_seconds: Math.round(timeSpentSeconds), // Número: cadastrar como Métrica Customizada no GA4
                engagement_level: getEngagementLevel(timeSpentSeconds)
            })
        }
    }
}

// Helper to categorize engagement level
const getEngagementLevel = (seconds: number): string => {
    if (seconds < 5) return 'glance'      // Quick glance
    if (seconds < 15) return 'brief'      // Brief view
    if (seconds < 30) return 'engaged'    // Good engagement
    return 'deep'                          // Deep engagement
}
